import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CheckBoxComponent from "../CheckBox";
import {
  AppDispatch,
  updateSystemUiModuleClear,
  updateSystemUiModuleRequest,
} from "../../../../../redux";
import { updateSystemUiModule } from "@src/redux/slices/system-ui-module/update-system-ui-module";

interface PageComponentRoleCheckBoxProps {
  pageComponent: any;
  role: { id?: string };
  key: number | string;
}

const PageComponentRoleCheckBox: React.FC<PageComponentRoleCheckBoxProps> = (
  props
) => {
  const { pageComponent, role } = props;
  const dispatch = useDispatch<AppDispatch>();

  const checkboxKey = `${pageComponent.id}_${role.id}`;
  const { result } = useSelector(updateSystemUiModule);

  const initialAccess = !!pageComponent?.roleList?.some(
    (x: any) => x?.id === role.id
  );
  const [hasAccess, setHasAccess] = useState<boolean>(initialAccess);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const next = !!pageComponent?.roleList?.some(
      (x: any) => x?.id === role.id
    );
    setHasAccess(next);
  }, [pageComponent, role.id]);

  useEffect(() => {
    if (loading && result?.status === "success") {
      setLoading(false);
      dispatch(updateSystemUiModuleClear());
    }
  }, [result]);

  const onChangePageAccess = (value: boolean) => {
    setHasAccess(value);
    setLoading(true);

    if (value) {
      dispatch(
        updateSystemUiModuleRequest({
          id: pageComponent.id,
          data: { roleIdList: [role?.id || ""] },
        })
      );
    } else {
      dispatch(
        updateSystemUiModuleRequest({
          id: pageComponent.id,
          data: { removableRoleIdList: [role.id || ""] },
        })
      );
    }
  };

  return (
    <CheckBoxComponent
      key={checkboxKey}
      isChecked={hasAccess}
      loading={loading}
      onChange={onChangePageAccess}
    />
  );
};

export default PageComponentRoleCheckBox;
